import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Terms from "@/views/Terms.vue"
import store from '../store'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/surveyView',
    name: 'SurveyView',
    component: () => import('../components/SurveyView.vue')
  },
  {
    path: '/surveyDetails/:survey_id',
    name: 'SurveyDetails',
    component: () => import('../components/SurveyDetails.vue')
  },
  {
    path: '/survey-list',
    name: 'Survey-list',
    component: () => import('../views/SurveyList.vue')
  },
  {
    path: '/surveys/:survey_id',
    name: 'Surveys',
    component: () => import('../views/SurveyPage.vue')
  },
  {
    path: '/terms-and-conditions',
    name: 'Terms',
    component: Terms
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

//checking that is the user logged in or not?
router.beforeEach((to, from, next) => {
  const currentUser = store.state.user;
  if(!currentUser) {
    if(to.path === '/') return next();
    if(to.path === '/terms-and-conditions') return next();
    if(to.path === '/surveyView') return next();
    next({ path: '/surveyView', name: "SurveyView"})
  }
  next()
})

export default router
